<template>
    <div class="user-role-view" v-loading="loading">
        <div class="row">

            <div class="col-md-4 mb-2">
                <el-button type="primary" @click="blukDelete" v-if="rights.delete">Bulk Delete</el-button>
                <el-button type="primary" @click="page.openDialog = true" v-if="rights.add">Add User Role</el-button>

                <el-dialog
                    title="User Role"
                    :visible.sync="page.openDialog"
                    width="50%"
                    :before-close="handleDialogClose"
                    v-loading="page.dialogLoding">
                    <span>
                        <div class="row">
                            <div class="col-md-12 mb-2">

                                <el-form ref="userRoleForm" :model="page.form" :rules="page.formRules" label-width="150px">

                                    <el-form-item label="User Role" prop="user_role">
                                        <el-input v-model="page.form.user_role" ref="user_role"></el-input>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="submitData" v-if="page.formBtnSubmit">Submit</el-button>
                                        <el-button type="primary" @click="resetData('userRoleForm')" v-if="page.formBtnSubmit">Reset</el-button>
                                        <el-button type="primary" @click="updateData" v-if="page.formBtnUpdate">Update</el-button>
                                    </el-form-item>

                                </el-form>

                            </div>
                        </div>

                    </span>
                </el-dialog>
            </div>

            <div class="col-md-4 mb-2">
            </div>

            <div class="col-md-4 mb-2">
                <el-input v-model="table.search" placeholder="Search By Name" v-if="rights.view" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <el-table
                    :data="table.tableData.filter(data => !table.search || data.user_role.toLowerCase().includes(table.search.toLowerCase()))"
                    :default-sort = "{prop: 'enquiry_date', order: 'descending'}"
                    style="width: 100%"
                    v-loading="table.loading"
                    @selection-change="handleSelectionChange"
                    v-if="rights.view">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column label="User Role" prop="user_role" sortable> </el-table-column>

                    <el-table-column
                        v-if="rights.edit || rights.delete"
                        align="right">
                        <template slot="header" slot-scope="scope">
                            Action
                        </template>
                        <template slot-scope="scope">
                            <el-button
                            v-if="rights.edit"
                            size="mini"
                            @click="handleEditClick(scope.$index, scope.row)">Edit</el-button>
                            <el-button
                            v-if="rights.delete"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="row" v-if="rights.view">
            <div class="col-md-12">
                <div class="block" style="text-align:center">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="[100, 200, 500]"
                    :page-size="pagination.perPageItem"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.totalData">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {generateHeader} from "@/misc/function.js";
export default {
    data () {

        const validUserRole = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Role'))
            } else {
                callback()
            }
        }
        return {
            loading: true,
            rights: {
                page: true,
                view: false,
                add: false,
                edit: false,
                delete: false,
                bulk_delete: false
            },
            page: {
                openDialog: false,
                dialogLoding: false,
                form: {
                    r_id: 0,
                    user_role: ''
                },
                formRules: {
                    user_role: [{ required: true, trigger: 'blur', validator: validUserRole }]
                },
                formBtnSubmit: true,
                formBtnUpdate: false,
                formValid: false
            },
            table: {
                search: '',
                loading: true,
                multipleSelection: [],
                tableData: []
            },
            pagination: {
                currentPage: 1,
                perPageItem: 100,
                totalData: 0
            }
        }
    },
    methods: {
        //Dialog Close Event
        handleDialogClose(done) {
            this.$confirm('Are you sure to close this dialog?')
            .then(_ => {
                this.resetData('userRoleForm')
                done();
            })
            .catch(_ => {});
        },
        handleFormValid(formRef){
            this.$refs[formRef].validate((valid) => {
                if(valid){
                    this.page.formValid = true
                }
                else{
                    this.page.formValid = false
                }
            });
        },
        //Page Size
        handleSizeChange(val) {
            this.pagination.perPageItem = val
            this.getData()
        },
        //Current Page
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.getData()
        },
        //Multi Select
        handleSelectionChange(val){
            this.table.multipleSelection = val
        },
        //Single row Edit
        handleEditClick(index, row) {
            this.page.form.r_id = row.r_id
            this.page.form.user_role = row.user_role
            
            this.page.formBtnSubmit = false
            this.page.formBtnUpdate = true

            this.page.openDialog = true
        },
        getRights() {
            this.loading = true
            this.$axios.post('user-role/rights.php' , {} , {
                headers: generateHeader("userRoleRights")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    //Whole Page Right
                    this.rights.page = response.data.body.rights.user_role_page == 1 ? true : false
                    // Rights
                    this.rights.add = response.data.body.rights.user_role_add == 1 ? true : false
                    this.rights.view = response.data.body.rights.user_role_view == 1 ? true : false
                    this.rights.edit = response.data.body.rights.user_role_edit == 1 ? true : false
                    this.rights.delete = response.data.body.rights.user_role_delete == 1 ? true : false
                    this.rights.bulk_delete = response.data.body.rights.user_role_bulk_delete == 1 ? true : false

                    this.getData();
                }
                else if(response.data.code == "403"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    this.$router.push('/admin/dashboard')
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        getData() {
            this.table.loading = true
            this.$axios.post("user-role/get.php" , {
                pageSize: this.pagination.perPageItem,
                page: this.pagination.currentPage
            },{
                headers: generateHeader("userRoleData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    this.table.tableData = response.data.body
                    this.pagination.totalData = parseInt(response.data.extra.totalData)
                }
                else if(response.data.code == "404"){
                    this.table.tableData = []
                    this.pagination.totalData = 0
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.table.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.table.loading = false
            })
        },
        submitData(){
            this.handleFormValid("userRoleForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                this.$axios.post("user-role/add.php", this.page.form, {
                    headers: generateHeader("UserRoleAdd")
                })
                .then((response) => {
                    if(response.data.code == "201"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('userRoleForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                   
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
            
        },
        updateData() {
            this.handleFormValid("userRoleForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                this.$axios.post("user-role/update.php", this.page.form, {
                    headers: generateHeader("userRoleEdit")
                })
                .then((response) => {
                    if(response.data.code == "204"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('userRoleForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                    
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
        },
        //Single row Delete
        handleDelete(index, row) {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('user-role/delete.php' , {
                    id: row.r_id
                }, {
                    headers: generateHeader("userRoleDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
            })
        },
        // Bluk Delete
        blukDelete() {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('user-role/bulk-delete.php' , {
                    data: this.table.multipleSelection
                }, {
                    headers: generateHeader("userRoleDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
                this.$notify.info({
                    title: 'Info',
                    message: "Delete Cancle !!!"
                });
            })
        },
        resetData(formName){
            this.$refs[formName].resetFields();
        }
    },
    mounted() {
        this.getRights()
    }
}

</script>


<style>
    .el-rate{
        line-height: 40px !important;
        font-size: 50px;
    }
</style>